import config from '../../config/config';

import postRequest from './base/post';
import postStream from './base/postStream';

export default {
  /**
   * Super admin auth login function
   * @param {any} data - Login credentials data
   * @returns {any} A promise that resolves with the login response
   */
  login: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/tenant-admin/v1/auth/login`, data);
  },
  /**
   * Self register API
   * @param {any} data - The registration data
   * @param {any} handleUploadProgress - The upload progress callback handler
   * @returns {any} A promise that resolves with registration status
   */
  selfRegistration: (data: any, handleUploadProgress: (progress: any) => void): Promise<any> => {
    return postStream(
      `${config.subscription.accountApiUrl}api/super-admin/v1/user-account/create`,
      data,
      true,
      handleUploadProgress,
    );
  },

  /**
   * super admin auth login function
   * @param {any} data - Access request data
   * @returns {any} A promise that resolves with access status
   */
  accessUtilityPortal: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/super-admin/v1/auth/access-utility-portal`, data);
  },
  /**
   * Super admin forgot password function
   * @param {any} data - Forgot password request data
   * @returns {any} A promise resolving to verification email response
   */
  forgotPassword: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/tenant-admin/v1/auth/forgot-password`, data);
  },
  /**
   * Consumer delete function
   * @param {any} data - The deletion data
   * @returns {any} A promise resolving to deletion request response
   */
  consumerDelete: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/end-consumer/v1/auth/delete-user-account`, data);
  },
  /**
   * Consumer delete verification otp function
   * @param {any} data - The OTP verification data
   * @returns {any} A promise resolving to verification response
   */
  consumerDeleteVerificationOTP: (data: any = {}): Promise<any> => {
    return postRequest(
      `${config.subscription.accountApiUrl}api/end-consumer/v1/users/delete-user-request`,
      data,
    );
  },
  /**
   * Verify reset password OTP API
   * @param {any} data data
   * @returns {any} Promise
   */
  resetPasswordOTPVerify: (data: any = {}): Promise<any> => {
    return postRequest(
      `${config.authApiUrl}api/tenant-admin/v1/auth/forgot-password-otp-verify`,
      data,
    );
  },
  /**
   * Verify reset password OTP API
   * @param {any} data data
   * @returns {any} Promise
   */
  createPassword: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/tenant-admin/v1/auth/reset-password`, data);
  },

  /**
   * Verify Email API
   * @param {any} data data
   * @returns {any} Promise
   */
  verifyEmail: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/tenant-admin/v1/auth/verify-email`, data);
  },
  /**
   * Verify Email API
   * @returns {any} Promise
   */
  resendEmailOTP: (): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/tenant-admin/v1/auth/resend-email-otp`);
  },
  /**
   * Reset password API
   * @param {any} data data
   * @returns {any} Promise
   */
  initialResetPassword: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/tenant-admin/v1/auth/initial-reset-password`, data);
  },
  /**
   * Verify Mobile API
   * @param {any} data data
   * @returns {any} Promise
   */
  verifyMobile: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/tenant-admin/v1/auth/verify-mobile`, data);
  },
  /**
   * Verify Email API
   * @returns {any} Promise
   */
  resendMobileOTP: (): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/tenant-admin/v1/auth/resend-sms-otp`);
  },
};
